import sample_01 from './exclusivAlu.jpg';

export const exclusiveAluImpressions = {
    sample_01,
};
